module.exports = __webpack_public_path__ + "img/kp.a9f988e5.svg";